import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { K } from "./apiServiceI18n";

const HEADER_BG = "#5f6878";

const actionButtonSx = {
  bgcolor: HEADER_BG,
  color: "#fff",
  textTransform: "none",
  boxShadow: "none",
  minWidth: 140,
  "&:hover": { bgcolor: "#4d5563", boxShadow: "none" },
};

/**
 * Cancel wizard confirmation (BR4.1) — "Are you sure you want to cancel?"
 */
export default function ApiServiceCancelWarningDialog({
  open,
  onClose,
  onSaveChanges,
  onConfirmCancel,
}) {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      className="dialog-top"
      slotProps={{
        root: { sx: { zIndex: (theme) => theme.zIndex.modal + 1 } },
      }}
      PaperProps={{ sx: { overflow: "hidden" } }}
    >
      <Box
        sx={{
          bgcolor: HEADER_BG,
          color: "#fff",
          py: 1.25,
          px: 2,
          textAlign: "center",
        }}
      >
        <Typography variant="subtitle1" sx={{ fontWeight: 700, letterSpacing: 0.5 }}>
          {t(K.WARNING)}
        </Typography>
      </Box>

      <DialogContent
        sx={{
          bgcolor: "#f3f4f6",
          display: "flex",
          alignItems: "center",
          gap: 2,
          py: 3,
          px: 3,
        }}
      >
        <Box
          aria-hidden
          sx={{
            width: 112,
            height: 112,
            flexShrink: 0,
            border: "1px solid #9e9e9e",
            bgcolor: "#e8e8e8",
            position: "relative",
            "&::before, &::after": {
              content: '""',
              position: "absolute",
              top: "50%",
              left: "12%",
              right: "12%",
              height: "1px",
              bgcolor: "#757575",
            },
            "&::before": { transform: "rotate(45deg)" },
            "&::after": { transform: "rotate(-45deg)" },
          }}
        />
        <Typography variant="body1" sx={{ color: "text.primary", lineHeight: 1.5 }}>
          {t(K.API_SVC_CANCEL_WARNING)}
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          bgcolor: "#f3f4f6",
          justifyContent: "flex-end",
          gap: 1,
          px: 3,
          pb: 2.5,
          pt: 0,
        }}
      >
        <Button variant="contained" onClick={onSaveChanges} sx={actionButtonSx}>
          {t(K.API_SVC_NO_SAVE_CANCEL)}
        </Button>
        <Button variant="contained" onClick={onConfirmCancel} sx={actionButtonSx}>
          {t(K.API_SVC_YES_CANCEL)}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
